import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorReport } from './errorReport';
import { environment } from '../../../environments/environment';
import { EnvironmentService } from '../environment/environment.service';
import { map } from 'rxjs/operators';
import { GetAllErrorReportsResponse } from '../../messaging/getAllErrorReportsResponse';

@Injectable({
  providedIn: 'root'
})
export class ErrorReportingService {

  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  submitErrorReport(errorReport: ErrorReport): Promise<ErrorReport> {
    //console.log('submitting new error report...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/ErrorReport/insertErrorReport`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const body = JSON.stringify(errorReport);
    //console.log(body);
    const result = this.httpClient.post<ErrorReport>(requestUrl, body, { headers });
    return result.toPromise();
  }

  getAllErrors(pageIndex: number, rowsPerPage: number): Promise<GetAllErrorReportsResponse> {
    console.log('getting error reports...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/ErrorReport/index?pageIndex=${pageIndex}&rowsPerPage=${rowsPerPage}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    // const body = JSON.stringify(errorReport);
    // //console.log(body);
    const result = this.httpClient.post<GetAllErrorReportsResponse>(requestUrl, { headers }).pipe(
      map((response) => {
        const data = response.errors;
        data.forEach(r => {
          r.createdDateTime = new Date(r.createdDateTime);
        });
        return response;
      }));

    return result.toPromise();
  }
}
